import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { merchantThemes, fonts, device } from 'components/Variable'

export const ReasonConditionBlock = styled.div`
	width: 100%;
	max-width: ${rem(550)};
	background: ${({ theme }) => theme.color.grayEleven};
	border: ${rem(1)} solid ${({ theme }) => theme.color.blackOne};
	box-sizing: border-box;
	border-radius: ${rem(2)};
	margin: ${rem(20)} auto 0 auto;
	padding: ${rem(21, 32)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			background: transparent;
			border-radius: ${rem(10)};
		`}

	${(p) =>
		p.isHighlighted &&
		css`
			border: ${rem(1)} solid ${({ theme }) => theme.color.redTwo};
		`}

	${(p) =>
		p.theme.name === merchantThemes.musto &&
		p.isHighlighted &&
		css`
			border: ${rem(1)} solid ${({ theme }) => theme.color.tertiary};
		`}
	
	@media (${device.mobileM}) {
		border: 0;
		background-color: transparent;
		padding: ${rem(21, 2)};
		margin: 0;
	}
`
export const ReasonConditionTitle = styled.div`
	font-family: ${fonts.openSans};
	font-style: normal;
	font-weight: 600;
	font-size: ${rem(16)};
	line-height: ${rem(26)};
	text-align: center;
	color: ${({ theme }) => theme.color.blackOne};
	margin-bottom: ${rem(15)};

	${(p) =>
		p.theme.name === merchantThemes.woodwood &&
		css`
			font-family: ${fonts.WWBeta8Regular};
		`}

	${(p) =>
		p.theme.name === merchantThemes.hh &&
		css`
			font-family: ${fonts.dinPro};
		`}
	 
    ${(p) =>
		p.theme.name === merchantThemes.marysia &&
		css`
			font-family: ${fonts.futura};
		`}
		
	${(p) =>
		p.theme.name === merchantThemes['8848'] &&
		css`
			font-family: ${fonts.futura};
		`}
		
	${(p) =>
		p.theme.name === merchantThemes.aycane &&
		css`
			font-family: ${fonts.IBMPlex};
		`}
		
	${(p) =>
		p.theme.name === merchantThemes.bymalina &&
		css`
			font-family: ${fonts.Avenir};
		`}
		
	${(p) =>
		p.theme.name === merchantThemes.henrylloyd &&
		css`
			font-family: ${fonts.Gotham};
		`}
		
	${(p) =>
		p.theme.name === merchantThemes.chimi &&
		css`
			font-family: ${fonts.AmericaExpandedRegular};
		`}
		
	${(p) =>
		p.theme.name === merchantThemes.ogoship &&
		css`
			font-family: ${fonts.usual};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-family: ${fonts.MonumentGrotesk};
			font-weight: normal;
			font-size: ${rem(15)};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.sns &&
		css`
			font-family: ${fonts.AktivGroteskEx};
		`}
	
	${(p) =>
		p.isHighlighted &&
		css`
			color: ${({ theme }) => theme.color.redTwo};
		`}
		
	${(p) =>
		p.theme.name === merchantThemes.musto &&
		p.isHighlighted &&
		css`
			color: ${({ theme }) => theme.color.tertiary};
		`}
	
	@media (${device.mobileM}) {
		font-size: ${rem(14)};
	}
`
export const ReasonConditionItem = styled.div`
	font-family: ${fonts.openSans};
	font-style: normal;
	font-weight: normal;
	font-size: ${rem(16)};
	line-height: ${rem(18)};
	color: ${({ theme }) => theme.color.blackOne};
	padding: ${rem(6, 0, 6, 35)};
	cursor: pointer;
	position: relative;

	${(p) =>
		p.theme.name === merchantThemes.woodwood &&
		css`
			font-family: ${fonts.WWBeta8Regular};
		`}

	${(p) =>
		p.theme.name === merchantThemes.hh &&
		css`
			font-family: ${fonts.dinPro};
		`}
	 
    ${(p) =>
		p.theme.name === merchantThemes.marysia &&
		css`
			font-family: ${fonts.futura};
		`}
	${(p) =>
		p.theme.name === merchantThemes['8848'] &&
		css`
			font-family: ${fonts.futura};
		`}
	${(p) =>
		p.theme.name === merchantThemes.chimi &&
		css`
			font-family: ${fonts.AmericaExpandedRegular};
		`}
		${(p) =>
		p.theme.name === merchantThemes.ogoship &&
		css`
			font-family: ${fonts.usual};
		`}
		${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-family: ${fonts.MonumentGrotesk};
		`}
		${(p) =>
		p.theme.name === merchantThemes.sns &&
		css`
			font-family: ${fonts.AktivGroteskEx};
		`}

	&:after,
	&:before {
		position: absolute;
		content: '';
		left: 0;
		width: ${rem(20)};
		height: ${rem(20)};
		border: ${rem(1)} solid ${({ theme }) => theme.color.blackOne};
		border-radius: 50%;
		top: 15%;
	}

	&:after {
		width: ${rem(12)};
		height: ${rem(12)};
		background: ${({ theme }) => theme.color.primary};
		border: none;
		display: none;
		margin-top: ${rem(4)};
		left: ${rem(4)};
	}

	&:hover {
		text-decoration: underline;
		&:after {
			display: block;
			background: ${({ theme }) => theme.color.grayNineteen};
		}
	}

	${(p) =>
		p.isActive &&
		css`
			&:after {
				display: block;
			}

			&:hover {
				&:after {
					background: ${({ theme }) => theme.color.primary};
				}
			}
		`}
`
